/* eslint-disable react/react-in-jsx-scope */
import { Checkbox } from "@mui/material"
import { FaMagnifyingGlass, FaTag } from "react-icons/fa6"

export const parseFinalPublicationsTable = ({
  data,
  filteredIds,
  isaAllChecked,
  onOpenDetails,
  onOpenTags,
  onAllSelected,
  onRowSelect,
  rowsSelected,
}) => {
  const columns = [
    {
      field: "select",
      sortable: false,
      disableColumnMenu: true,

      renderHeader: () => {
        return filteredIds.length ? (
          <Checkbox
            checked={isaAllChecked}
            sx={{ "&.Mui-checked": { color: "#677de8" } }}
            onClick={({ target }) => onAllSelected(target.checked)}
          />
        ) : null
      },
      width: 2,
      renderCell: params => {
        return (
          <Checkbox
            checked={rowsSelected.some(
              item => params.row.Id === item.id && !!item.isSend
            )}
            sx={{ "&.Mui-checked": { color: "#677de8" } }}
            onClick={({ target }) => {
              onRowSelect(params.row.Id, !target.checked)
            }}
          />
        )
      },
    },
    {
      field: "codUnicoPublicacao",
      headerName: "Código Único",
      flex: 1,
      renderCell: params => <div>{params.row.codUnicoPublicacao || "N/A"}</div>,
    },
    {
      field: "DataDisponibilizacao",
      headerName: "Disponibilização",
      flex: 1,
      renderCell: params => (
        <div>
          {params.row.DataDisponibilizacao
            ? new Date(params.row.DataDisponibilizacao).toLocaleDateString(
                "pt-BR"
              )
            : "N/A"}
        </div>
      ),
    },
    {
      field: "DataPublicacao",
      headerName: "Publicação",
      flex: 1,
      renderCell: params => (
        <div>
          {params.row.DataPublicacao
            ? new Date(params.row.DataPublicacao).toLocaleDateString("pt-BR")
            : "N/A"}
        </div>
      ),
    },
    {
      field: "nomeEstado",
      headerName: "Estado",
      flex: 1,
      renderCell: params => <div>{params.row.nomeEstado || "N/A"}</div>,
    },
    {
      field: "nomeDiario",
      headerName: "Diário",
      flex: 1,
      renderCell: params => <div>{params.row.nomeDiario || "N/A"}</div>,
    },
    {
      field: "orgaoCompleto",
      headerName: "Órgão",
      flex: 1.5,
      renderCell: params => <div>{params.row.orgaoCompleto || "N/A"}</div>,
    },
    {
      field: "nomeComarca",
      headerName: "Comarca",
      flex: 1.5,
      renderCell: params => <div>{params.row.nomeComarca || "N/A"}</div>,
    },
    {
      field: "nomeOrgao",
      headerName: "Órgão (resumido)",
      flex: 1,
      renderCell: params => <div>{params.row.nomeOrgao || "N/A"}</div>,
    },
    {
      field: "conteudoComplementar",
      headerName: "Complemento",
      flex: 1,
      renderCell: params => (
        <div>{params.row.conteudoComplementar || "N/A"}</div>
      ),
    },
    {
      field: "tag",
      headerName: "Tag/Obs",
      flex: 1.5,
      renderCell: params => (
        <div
          style={{
            cursor: "pointer",
          }}
          onClick={() => onOpenTags(params.row)}
        >
          <FaTag
            size={16}
            color={
              rowsSelected.some(
                item =>
                  (params.row.Id === item.id && !!item.tag) ||
                  (params.row.Id === item.id && !!item.observacao)
              )
                ? "green"
                : "#677de8"
            }
          />
        </div>
      ),
    },
    {
      field: "detalhes",
      headerName: "Detalhes",
      flex: 1,
      renderCell: params => (
        <div
          style={{
            cursor: "pointer",
          }}
          onClick={() => onOpenDetails(params.row)}
        >
          <FaMagnifyingGlass size={16} color="#677de8" />
        </div>
      ),
    },
  ]

  const rows = data ? data.map(item => ({ ...item, id: item.Id })) : []

  return { columns, rows }
}
